import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import './index.scss'
import {MoonIcon} from '../../../icons'
import classNames from 'classnames'
import {colors} from '../../../utils/colors'
import {setIsDarkMode} from '../../../stores/sidebar'

const  DarkModeSwitcher = () => {
    const dispatch = useDispatch()
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const sidebarIsActive = useSelector(state => state.sidebar.sidebarIsActive)

    const handleClick = () => {
        dispatch(setIsDarkMode(!isDarkMode))
    }

    return (
        <div className="mode-switcher">
            <div
                className={classNames('switcher', {
                    'active': isDarkMode,
                    'mobile-switcher': !sidebarIsActive
                })}
                onClick={handleClick}
            />
            {sidebarIsActive && <MoonIcon stroke={!isDarkMode  ? '' : colors.colorBlue} />}
        </div>
    )
}

export default  DarkModeSwitcher
